import React from "react";

const CopyIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.48856 21.8062H5.56634V21.7284V8.20493C5.56634 7.25109 6.34239 6.47503 7.29624 6.47503H10.1125H10.1903V6.39725V5.78125V5.70347H10.1125H7.29624C5.91714 5.70347 4.79478 6.82524 4.79478 8.20493V21.7284V21.8062H4.87256H5.48856Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M13.9998 22.8614H14.0776V22.8596C15.4208 22.8184 16.5012 21.713 16.5012 20.3594V6.83594V6.75816H16.4235H15.8075H15.7297V6.83594V20.3599C15.7297 21.3138 14.9536 22.0898 13.9998 22.0898H10.3833H10.3055V22.1676V22.7836V22.8614H10.3833H13.9998Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M13.3276 9.67578V9.598H13.2498H8.04688H7.9691V9.67578V10.2918V10.3696H8.04688H13.2498H13.3276V10.2918V9.67578Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M13.3276 12V11.9222H13.2498H8.04688H7.9691V12V12.616V12.6938H8.04688H13.2498H13.3276V12.616V12Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M13.3276 14.3242V14.2464H13.2498H8.04688H7.9691V14.3242V14.9402V15.018H8.04688H13.2498H13.3276V14.9402V14.3242Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M13.3276 16.6484V16.5707H13.2498H8.04688H7.9691V16.6484V17.2644V17.3422H8.04688H13.2498H13.3276V17.2644V16.6484Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M13.3276 18.9766V18.8988H13.2498H8.04688H7.9691V18.9766V19.5926V19.6703H8.04688H13.2498H13.3276V19.5926V18.9766Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M12.1912 8.29417H12.269V8.2164V6.22056C12.269 5.26671 13.045 4.49065 13.9989 4.49065H17.6154H17.6931V4.41288V3.79688V3.7191H17.6154H13.9989C12.6198 3.7191 11.4974 4.84087 11.4974 6.22056V8.2164V8.29417H11.5752H12.1912Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M17.0082 20.7987V20.8765H17.0859H20.7024C22.0815 20.8765 23.2039 19.7547 23.2039 18.375V4.85156V4.77378H23.1261H22.5101H22.4323V4.85156V18.375C22.4323 19.3288 21.6563 20.1049 20.7024 20.1049H17.0859H17.0082V20.1827V20.7987Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M20.0301 7.69141V7.61363H19.9523H17.3511H17.2733V7.69141V8.30741V8.38518H17.3511H19.9523H20.0301V8.30741V7.69141Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M20.0301 10.0156V9.93785H19.9523H17.3511H17.2733V10.0156V10.6316V10.7094H17.3511H19.9523H20.0301V10.6316V10.0156Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M20.0301 12.3398V12.2621H19.9523H17.3511H17.2733V12.3398V12.9558V13.0336H17.3511H19.9523H20.0301V12.9558V12.3398Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M20.0301 14.6641V14.5863H19.9523H17.3511H17.2733V14.6641V15.2801V15.3578H17.3511H19.9523H20.0301V15.2801V14.6641Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
      <path
        d="M20.0301 16.9922V16.9144H19.9523H17.3511H17.2733V16.9922V17.6082V17.686H17.3511H19.9523H20.0301V17.6082V16.9922Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.155556"
      />
    </svg>
  );
};

export default CopyIcon;
